<template>
<FormsCard>
    <router-link to="/auth" class="auth-back-link">
      <font-awesome-icon icon="fa-arrow-left"/>
      {{ $t('SuccessEmailResetComponent.backToLogin') }}
    </router-link>
    <img class="block mx-auto mb-6 w-32 sm:w-40 h-auto" src="@/assets/omind_logo.png" alt="test">
    <h2 class="text-center pb-5 text-xl sm:text-2xl">
        {{ $t('SuccessEmailResetComponent.emailSent') }}</h2>
    <p class="text-center px-2 text-base sm:text-lg">
        {{ $t('SuccessEmailResetComponent.emailSentMessage') }}</p>
  </FormsCard>
</template>

<script>
import FormsCard from '../global/slots/FormsCard.vue';

export default {
  name: 'SuccessEmailResetComponent',
  components: {
    FormsCard,
  },
};
</script>
